import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { AccountWithAmountItem, CardViewComponent } from '@iw/common';
import { AccountType } from '@iw/core/entities';

@Component({
  selector: 'iw-account-item',
  standalone: true,
  templateUrl: './account-item.component.html',
  styleUrls: ['./account-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, IconModule, CardViewComponent],
  host: {
    '[class.selected]': 'selected()',
  },
})
export class AccountItemComponent {
  account = input.required<AccountWithAmountItem>();
  defaultCurrency = input<string>('USD');
  selected = input(false, { transform: booleanAttribute });

  accountTypeEnum = AccountType;

  readonly accountType = computed(() => {
    return this.account().accountType;
  });

  walletImgSrc = computed(() => {
    const theme = this.selected() ? 'light' : 'dark';
    return `/assets/images/wallet-${theme}.png`;
  });
}
